import ReportPageService from "../../service/ReportPageService";
import moment from "moment/moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons/faMagnifyingGlass";

const Component = ({ value, attributeName, transaction }) => {
  const getMerchantClickUrl = (value, transaction) => {
    return (
      "#/report?merchantCodes=" +
      value +
      "&trnDateMax=" +
      moment(transaction.trnDate)
        .add(60, "minutes")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss") +
      "&trnDateMin=" +
      moment(transaction.trnDate)
        .subtract(90, "days")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss") +
      "&highlightTransactionIds=" +
      [transaction.id] +
      "&pageSize=" +
      200
    );
  };

  const getPanClickUrl = (value, transaction) => {
    return (
      "#/report?pans=" +
      value +
      "&trnDateMax=" +
      moment(transaction.trnDate)
        .add(60, "minutes")
        .format("YYYY-MM-DDTHH:mm:ss") +
      "&trnDateMin=" +
      moment(transaction.trnDate)
        .subtract(90, "days")
        .format("YYYY-MM-DDTHH:mm:ss") +
      "&highlightTransactionIds=" +
      [transaction.id] +
      "&pageSize=" +
      200
    );
  };

  return (
    <>
      {(attributeName.includes("merchantCode") && (
        <>
          <small>
            <a
              href={getMerchantClickUrl(value, transaction)}
              target="_blank"
              rel="noreferrer"
            >
              <FontAwesomeIcon icon={faMagnifyingGlass} />
            </a>
          </small>
          &nbsp;
          {ReportPageService.renderPrettyValue(value)}
        </>
      )) ||
        (attributeName.includes("pan") && (
          <>
            <small>
              <a
                href={getPanClickUrl(value, transaction)}
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </a>
            </small>
            &nbsp;
            {ReportPageService.renderPrettyValue(value)}
          </>
        )) || <>{ReportPageService.renderPrettyValue(value)}</>}
    </>
  );
};

export default Component;
